export const appNames = {
  Vulnerabilities: 'Vulnerabilities',
  Threats: 'Threats',
  Assets: 'Assets',
  Identities: 'Identities',
} as const;

export type AppName = (typeof appNames)[keyof typeof appNames];
